import React, { createContext, useEffect, useState } from 'react';
import { loadConfig } from '../config/config';


export const BaseUrlContext = createContext();

export const BaseUrlProvider = ({ children }) => {
  const [baseUrl, setBaseUrl] = useState('');
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      const loadedConfig = await loadConfig();

      if (loadedConfig && loadedConfig.ApiUrl) {
        setConfig(loadedConfig);
        setBaseUrl(loadedConfig.ApiUrl);
      } else {
        console.error('Config file missing or invalid!');
      }

      setLoading(false);
    };

    fetchConfig();
  }, []);

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>Loading configuration...</div>;
  }

  return (
    <BaseUrlContext.Provider value={{ baseUrl, setBaseUrl, config, setConfig }}>
      {children}
    </BaseUrlContext.Provider>
  );
};
